(ns app.styles
  (:require-macros)
  (:require [garden.stylesheet :refer [at-media]]
            [spade.core   :refer [defclass defglobal]]))

(defglobal theme-values
  [":root" {:theme/*purplePrimary* "#7070FA"
            :theme/*purpleHover* "#5555F2"
            :theme/*purpleActive* "#4F56CF"
            :theme/*purple100* "#E2E2FC"
            :theme/*disabled* "#BEC0CC"
            :theme/*purple500* "#6E75F2"
            :theme/*purpleHoverSecondary* "#DADBFA"
            :theme/*purplePrimaryLightFocus* "#A6A6FF"
            :theme/*purplePrimaryLight* "#EBEBFF"
            :theme/*purpleHoverThird* "#F7F7FE"
            :theme/*dark95* "#F0F0F2"
            :theme/*dark21* "#2B2A35"
            :theme/*dark40* "#605D65"
            :theme/*dark98* "#E0DFE4"
            :theme/*redPrimary* "#FF4975"
            :theme/*redHover* "#FF2157"
            :theme/*redActive* "#ED2153"
            :theme/*redHoverSecondary* "#FFF4F7"
            :theme/*redPrimaryLight* "#FFE5EC"
            :theme/*grey100* "#FCFDFF"
            :theme/*grey200* "#F7F8FA"
            :theme/*grey300* "#F0F1F2"
            :theme/*grey350* "#dddddd6b"
            :theme/*grey400* "#CACBCC"
            :theme/*surface98* "#F6F6F9"
            :theme/*green* "#2BCCB9"
            :theme/*red* "#FF4975"
            :theme/*surface100* "#FFFFFF"
            :theme/*additionalGeraldine* "#FC7E92"
            :theme/*greyBorderColor* "#EAE6F2"}])

(defglobal defaults
  [:body
   {:font-family "'Nunito Sans' !important"
    :font-size "16px"
    :color :theme/*dark21*
    :background-color :theme/*surface98*}]
  [:button {:font-family "'Nunito Sans'"
            :font-size "16px"
            :color :theme/*dark21*
            :cursor "pointer"}
   [:&:disabled
    {:cursor "default"}]
   ])

(defclass app-bar
  []
  {:padding "0px 24px"
   :border-bottom "1px solid"
   :border-color :theme/*dark98*
   :align-items "center !important"
   :background-color "white"
   :height "55px"})

(defclass new-workspace-container
  []
  {:background-color "white"
   :padding "100px 56px"
   :border-radius "8px"})

(defclass create-workspace-title
  []
  {:font-weight "900"
   :font-size "36px"})

(defclass create-workspace-space
  []
  {:margin-bottom "30px !important"})

(defclass creator-name
  []
  {:font-size "12px"
   :font-weight "600"})
(defclass workspace-name
  []
  {:font-size "16px"
   :color :theme/*dark40*
   :font-weight "700"})

(defclass sidebar
  []
  {:height "90vh"
   :background "#F6F6F9"
   :padding "24px 20px 0px 12px"})

(defclass folders-list
  []
  {:background "white"
   :padding-top "24px"
   :border-right "1px solid"
   :border-color :theme/*dark98*
   :height "calc(100vh - 80px)"})

(defclass activity-card-style
  []
  {:align "start"
   :margin "0px 24px"
   :gap "8px"
   :width "21%"
   :background-color "white"})


(defclass create-activity-card-style
  []
  {:background "white"
   :border-radius "8px"})

(defn folder-header-style
  [name]
  {:color (if (= name "") "#CACBCC" "black") ;;for some reason, :theme/*grey400* isn't working
   })



(defclass statistics-tab-selector-style
  [is-active?]
  {:background-color (if is-active? :theme/*purplePrimaryLight* "white")
   :border-radius "4px"
   :padding "9px 54px 9px 54px"
   :border "0px "
   :justify-content :end}
  [:&:hover
   {:background-color :theme/*purplePrimaryLight*}])


(defclass statistics-tab-selector-position-style
  []
  {:justify-content :end})

(defclass statistics-tab-selector-on-hover-style
  []
  {:background "black"})

(defclass create-activity-section-style
  []
  {:background "white"
   :min-height "185px"
   :border-radius "8px"
   :padding "12px 24px 24px"
   :border "1px solid #CACBCC"
   :gap "24px"})

(defclass break-line-style
  []
  {:size  "1px"
   :color "#E0DFE4"})

(defclass folders-list-item
  []
  {:padding "0px 16px"
   :height "calc(100vh - 429px)"})

(defclass folders-list-item-padding
  []
  {:padding "3px 16px"})

(defclass menu-bottom-border
  []
  {:border-top "1px solid"
   :border-color :theme/*grey300*})


(defclass dashboard-screen
  []
  {:padding "24px 24px 0px"
   :height "calc(90vh - 60px)"})

(defclass downward
  []
  {:flex "0 !important"})

(defclass upward
  []
  {:flex "0 !important"}
  [:&::before
   {:background-color "transparent"
    :content "''"
    :display "block"
    :border-top "1px solid #7070FA"
    :position "absolute"
    :left "9px"
    :bottom "2px"
    :width "81%"
    :border-color :theme/*purplePrimary*}])

(defclass normal
  []
  {:padding-bottom "3px"})

(defclass card-drop-over
  [] {:border "1px solid "
      :border-color :theme/*purplePrimary*
      :border-radius "8px"
      :width "277px !important"
      :height "40px !important"})

(defclass menu-view-buttons-wrapper
  []
  {:height "40px"
   :align-items "center !important"
   :border "1px solid "
   :border-color  :theme/*purplePrimaryLight*
   :border-radius "8px !important"})

(defclass menu-view-left-button
  [view]
  {:border-color :theme/*purplePrimaryLight*

   :background-color (if (= true view) :theme/*purplePrimaryLight* "")
   :padding "8px"}
  [:&:hover
   {:background-color :theme/*purplePrimaryLight*}])

(defclass menu-view-right-button
  [view]
  {:border-color :theme/*purplePrimaryLight*
   :background-color (if (= true view) :theme/*purplePrimaryLight* "")
   :padding "8px"}
  [:&:hover
   {:background-color :theme/*purplePrimaryLight*}])

(defclass grid-view-border
  []
  {:border "none"
   :border-top "2px solid"
   :border-color :theme/*greyBorderColor*
   :width "90%"})
